"use client";

import { useTranslation } from "react-i18next";

interface AddToCartButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
}

export default function AddToCartButton({
  onClick,
  disabled = false,
  label,
}: AddToCartButtonProps) {
  const { t } = useTranslation();

  const defaultLabel = label || t("common.addToCart");
  return (
    <button
      id="Add-to-cart-button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full h-10 text-white font-arial text-[15px] sm:text-[18px] font-medium leading-8 rounded-tl-[32px] rounded-br-[32px] border-none inline-block no-underline text-center ${
        disabled
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#ff0000] cursor-pointer"
      }`}
      aria-label={defaultLabel}
      data-test-id={
        disabled ? "add-to-cart-button-disabled" : "add-to-cart-button"
      }
    >
      {defaultLabel}
    </button>
  );
}
